import LoggedInBoilerplate from "../LoggedInBoilerplate";
import styled from "styled-components";
import NomenclatureOfSite from "../nomenclature/NomenclatureOfSite";
import NomenclatureOfEmployee from "../nomenclature/NomenclatureOfEmployee";
import NomenclatureOfVacation from "../nomenclature/NomenclatureOfVacation";
import NomenclatureOfDispute from "../nomenclature/NomenclatureOfDispute";
import NomenclatureOfComment from "../nomenclature/NomenclatureOfComment";
import NomenclatureOfAbsence from "../nomenclature/NomenclatureOfAbsence";
import NomenclatureOfZone from "../nomenclature/NomenclatureOfZone";
import { useState } from "react";
import MaterialInput from "../../../helperComponents/MaterialInput";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const Row2Section = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`;

const DataColumn = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 49%;
  gap: 30px;
`;

const SearchContainer = styled.div`
  width: 62%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
`;

export default function SearchPage() {
  let title1 = "page de";
  let title2 = "recherche";

  const [tmpValue, setTmpValue] = useState(null);
  const [inheritedSearchQuery, setInheritedSearchQuery] = useState(null);

  return (
    <LoggedInBoilerplate titleLine1={title1} titleLine2={title2}>
      <Container>
        <SearchContainer>
          <MaterialInput
            label={"Recherche"}
            value={tmpValue}
            onEnter={(e) => {
              setInheritedSearchQuery(e.target.value);
            }}
            onChange={(e) => {
              setTmpValue(e.target.value);
            }}
          />
        </SearchContainer>

        {inheritedSearchQuery ? (
          <Row>
            <Column>
              <NomenclatureOfEmployee
                disableFilters={true}
                inheritedSearchQuery={inheritedSearchQuery}
              />
              <NomenclatureOfAbsence
                disableFilters={true}
                inheritedSearchQuery={inheritedSearchQuery}
              />
              <NomenclatureOfDispute
                disableFilters={true}
                inheritedSearchQuery={inheritedSearchQuery}
              />
              <NomenclatureOfZone
                disableFilters={true}
                inheritedSearchQuery={inheritedSearchQuery}
              />
            </Column>
            <Column>
              <NomenclatureOfSite
                disableFilters={true}
                inheritedSearchQuery={inheritedSearchQuery}
              />
              <NomenclatureOfComment
                disableFilters={true}
                inheritedSearchQuery={inheritedSearchQuery}
              />
              <NomenclatureOfVacation
                disableFilters={true}
                inheritedSearchQuery={inheritedSearchQuery}
              />
            </Column>
          </Row>
        ) : null}
      </Container>
    </LoggedInBoilerplate>
  );
}
